module.exports = __webpack_public_path__ + "static/media/trash.d93f8034.svg";